import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {Link} from 'react-router';

const NavLink = createReactClass({
  propTypes: {
    to: PropTypes.string.isRequired,
    activeClassName: PropTypes.string,
    activeOnIndex: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  },

  contextTypes: {
    router: PropTypes.object,
  },

  getDefaultProps() {
    return {
      className: 'nav-link',
      activeClassName: 'nav-item active',
      activeOnIndex: false,
    };
  },

  render() {
    const {to, activeClassName, activeOnIndex, ...props} = this.props;
    const {router} = this.context;

    const activeClass = (router.isActive(to, activeOnIndex)) ? activeClassName : 'nav-item';

    return (
      <li className={activeClass}>
        <Link to={to} {...props}>{this.props.children}</Link>
      </li>
    );
  },
});

export default NavLink;



// WEBPACK FOOTER //
// ./app/javascript/components/NavLink.js